import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useId } from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { getSlateName } from "../../services/Slates";
var SummaryBox = styled("section")(function (_a) {
    var theme = _a.theme;
    return ({
        margin: "16px 0 0",
        padding: "16px",
        borderRadius: "8px",
        border: "1px solid ".concat(theme.palette.customGrey.light),
        backgroundColor: theme.palette.lightBackground,
    });
});
var SummaryList = styled("ul")({
    margin: "8px 0 0",
    paddingInlineStart: "20px",
    fontSize: "0.875rem",
});
export var ReviewSelectionSummary = function (_a) {
    var summary = _a.summary, defaultLanguage = _a.defaultLanguage;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var titleId = useId();
    var hasLines = summary.slates.length > 0 || summary.independent > 0;
    return (_jsxs(SummaryBox, { className: "review-selection-summary", "aria-labelledby": titleId, children: [_jsx(Typography, { className: "review-selection-title", component: "h2", id: titleId, sx: { fontSize: "1rem", fontWeight: 700, margin: 0 }, children: t("slates.review.title") }), _jsx(Typography, { className: "review-selection-total", variant: "body2", sx: { margin: "8px 0 0" }, children: t("slates.review.total", { selected: summary.selected, seats: summary.seats }) }), hasLines ? (_jsxs(SummaryList, { className: "review-selection-lines", children: [summary.slates.map(function (_a) {
                        var slate = _a.slate, slateSummary = _a.summary;
                        return (_jsx("li", { className: "review-selection-slate review-selection-slate-".concat(slateSummary.status), children: t("slates.review.slate", {
                                slate: getSlateName(slate, i18n.language, defaultLanguage),
                                status: t("slates.selection.".concat(slateSummary.status), {
                                    selected: slateSummary.selected,
                                    total: slateSummary.total,
                                }),
                            }) }, slate.id));
                    }), summary.independent > 0 ? (_jsx("li", { className: "review-selection-independent", children: t("slates.review.independent", { count: summary.independent }) })) : null] })) : null, _jsx(Typography, { className: "review-selection-note", variant: "body2", sx: { margin: "8px 0 0" }, children: t("slates.review.note") })] }));
};
